var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58789 1.1875C3.93002 1.1875 1.77539 3.34213 1.77539 6C1.77539 8.65787 3.93002 10.8125 6.58789 10.8125C9.24576 10.8125 11.4004 8.65787 11.4004 6C11.4004 3.34213 9.24576 1.1875 6.58789 1.1875ZM0.900391 6C0.900391 2.85888 3.44677 0.3125 6.58789 0.3125C9.72901 0.3125 12.2754 2.85888 12.2754 6C12.2754 9.14112 9.72901 11.6875 6.58789 11.6875C3.44677 11.6875 0.900391 9.14112 0.900391 6ZM6.00456 3.375C6.00456 3.05283 6.26572 2.79167 6.58789 2.79167C6.91006 2.79167 7.17122 3.05283 7.17122 3.375C7.17122 3.69717 6.91006 3.95833 6.58789 3.95833C6.26572 3.95833 6.00456 3.69717 6.00456 3.375ZM7.02539 8.91667V4.83333H6.15039V8.91667H7.02539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhiteIcon);
export default __webpack_public_path__ + "static/media/info-white-icon.c42ca7616379ad9d7a7f22f4c3f70221.svg";
export { ForwardRef as ReactComponent };